import CityPagesTable from "../../components/city-pages/CityPagesTable";
import HeaderPage from "../../components/lines-managements/header/HeaderPage";

const CityPages: React.FC = () => (
  <>
    <HeaderPage hasNoInput={true} />
    <CityPagesTable />
  </>
);

export default CityPages;
